





























































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import { cloneDeep } from "lodash";
import { getCohorts } from "@/api/cohorts";
import { getStudentInstances, createStudentInstances, startStudentInstances, stopStudentInstances, resetStudentInstances, terminateStudentInstances, addTimeForStudentInstances } from "@/api/studentInstances";
import {
  IContact,
  ICohort,
  IEnrollment,
  ILab,
  IStudentInstance
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { CohortModule } from "@/store/modules/cohort";
import { UserModule } from "@/store/modules/user";
import { getMinutesDiffFromNow } from "@/utils/timeHelpers";
import * as moment from 'moment';
import { MachineType } from "@/api/enums";
import { EventBus } from "@/utils/eventBus";
import { guacClientUrl } from '@/config';

@Component({
  name: "StudentLabInstance",
  components: {
    Pagination
  }
})
export default class extends Vue {
  private tableKey = 0;
  private studentInstances: IStudentInstance[] = [];
  private filteredStudentInstances: IStudentInstance[] = [];
  private total = 0;
  private listLoading = true;
  private listQuery = {
    cohortName: undefined,
    userEmail: "",
    page: 1,
    limit: 20,
    sort: "+id"
  };
  private selectedStudentInstances: IStudentInstance[] = [];
  private dialogPageviewsVisible = false;
  private pageviewsData = [];
  private inactionStates: string[] = ["None", "Terminated", "Starting", "Stopping", "Resetting"];
  private noDataMessage: string = "There is no machine assigned to you. Please contact your instructor.";
  private searchTerm: string = "";

  created() {
    this.getList();
    this.getStudentInstances();
    this.$cyberlabHub.$on("student-instance-status-updated", this.onStudentInstanceStatusUpdated);
    EventBus.$on("student-instances-search", this.filterBySearch);
  }

  destroyed() {
    this.$cyberlabHub.$off("student-instance-status-updated", this.onStudentInstanceStatusUpdated);
    EventBus.$off("student-instances-search", this.filterBySearch);
  }

  private filterBySearch(data: any) {
    this.searchTerm = data.value;
    this.filterStudentInstances();
  }

  private filterStudentInstances() {
    this.filteredStudentInstances = this.studentInstances
    this.filteredStudentInstances = this.filterBySearchTerm(this.filteredStudentInstances);
  }

  private filterBySearchTerm(studentInstances: IStudentInstance[]) {
    if (this.searchTerm !== "") {
      return studentInstances.filter((si: IStudentInstance) => {
        if (si.enrollment.name) {
          return si.enrollment.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        }
        return false;
      });
    }
    return studentInstances;
  }

  get showNoDataWarning() {
    return this.total === 0 && !this.listLoading
  }

  private onStudentInstanceStatusUpdated(data: any) {
    let studentInstance: IStudentInstance = data.studentInstance
    let status: string = data.status
    let timeToShutDown: string = studentInstance.timeToShutDown
    let message: string = "";
    let messageType : "info" | "success" | "warning" | "error" = "info";
    let targetStudentInstance : IStudentInstance | undefined = this.getStudentInstanceById(studentInstance.id);

    switch(status) {
      case "Active": {
          message = `is ready`
          messageType = "success"
          break;
      }
      case "Inactive": {
          message = `has stopped`
          messageType = "warning"
          break;
      }
      case "Terminated": {
          message = `has terminated`
          messageType = "error"
          break;
      }
    }

    if (this.updateStudentInstanceStatus(targetStudentInstance, status, timeToShutDown)) {
      this.$notify({
        title: "Lab Instance",
        message: `Lab instance for ${studentInstance.enrollment.name} ${message}.`,
        type: messageType,
        duration: 5000
      });
    }
  }

  private getStudentInstanceById(id: string): IStudentInstance | undefined {
    return this.studentInstances.find(el => el.id === id);
  }

  private updateStudentInstanceStatus(studentInstance: IStudentInstance | undefined, status: string, timeToShutDown: string = "") {
    if (studentInstance && studentInstance.instanceStatus !== status) {
      studentInstance.instanceStatus = status;
      if (timeToShutDown !== "") {
        studentInstance.timeToShutDown = timeToShutDown;
      }
      return true;
    }
    return false;
  }

  private updateStudentInstanceStatusId(id: string, status: string) {
    let studentInstance: IStudentInstance | undefined = this.getStudentInstanceById(id);
    this.updateStudentInstanceStatus(studentInstance, status);
  }

  private updateStudentInstanceStatusIds(ids: string[], status: string) {
    ids.forEach(i => this.updateStudentInstanceStatusId(i, status));
  }

  get cohorts() {
    return CohortModule.cohorts;
  }

  private async getList() {
    this.listLoading = true;
    await getCohorts({}).then((response: any) => {
      let data = response.data;
      CohortModule.SetCohorts(data);
    });
  }

  private async getStudentInstances() {
    this.listLoading = true;
    await getStudentInstances(this.listQuery).then(
      (response: any) => {
        let data = response.data;
        this.studentInstances = data;
        this.filterStudentInstances();
        this.total = this.studentInstances.length;
        this.listLoading = false;
      },
      (error: any) => {
        console.log(error);
        this.listLoading = false;
      }
    );
  }

  private getTimeRemaining(status: string, time: string): string {
    if (status !== "Active") {
      return "00:00:00";
    } else {
        let timeDiffInSeconds: number = this.getTimeRemainingInSeconds(time);
        if (timeDiffInSeconds <= 0) {
          return "00:00:00";
        } else {
          let duration = moment.duration(timeDiffInSeconds, 'seconds');
          return duration.humanize();
        }
    }
  }

  private getTimeRemainingInSeconds(time: string): number {
    let fromTime = moment.utc(new Date().toUTCString());
    let toTime = moment.utc(new Date(time).toUTCString());
    let timeDiffInSeconds: number = toTime.unix() - fromTime.unix();
    return timeDiffInSeconds;
  }

  private WindowBox(machineType: MachineType): boolean {
    return machineType === MachineType.Window;
  }

  private UbuntuBox(machineType: MachineType): boolean {
    return machineType === MachineType.Ubuntu;
  }

  private reloadStudentInstances() {
    this.getStudentInstances();
  }

  private isInLaunchConditions(status: string): boolean {
    return status === "Active";
  }

  private isInactionState(status: string): boolean {
    return this.inactionStates.indexOf(status) >= 0;
  }

  private nonStartState(status: string): boolean {
    return this.isInactionState(status) || status === "Active";
  }

  private nonStopState(status: string): boolean {
    return this.isInactionState(status) || status === "Inactive";
  }

  private nonResetState(status: string): boolean {
    return this.isInactionState(status);
  }

  private showTerminalButton(row: IStudentInstance): boolean {
    return this.isInLaunchConditions(row.instanceStatus) && !this.WindowBox(row.box.machineTypeCode) && row.box.isStudentMachine;
  }

  private showDesktopButton(row: IStudentInstance): boolean {
    return this.isInLaunchConditions(row.instanceStatus) && !this.UbuntuBox(row.box.machineTypeCode) && row.box.isStudentMachine;
  }

  private handleCohortSelection(data: any) {
    this.listQuery.cohortName = data;
    this.getStudentInstances();
  }

  private sortChange(data: any) {}

  private handleSelectionChange(data: IStudentInstance[]) {
    this.selectedStudentInstances = data;
  }


  private handleActionCommand(row: IStudentInstance, command: any) {
    let action = ""
    switch(command) {
        case "Start": {
            this.startInstances([row]);
            action = "Starting"
            break;
        }
        case "Stop": {
            this.stopInstances([row]);
            action = "Stopping"
            break;
        }
        case "Reset": {
            this.resetInstances([row]);
            action = "Reseting"
            break;
        }
    }

    this.$notify({
          title: "Lab Instance",
          message: `${action} lab instance(s)...`,
          type: "info",
          duration: 5000
        });
  }

  private startInstances(studentInstances: IStudentInstance[]){
    startStudentInstances({ studentInstances: studentInstances }).then(
      (response: any) => {
        this.updateStudentInstanceStatusIds(studentInstances.map(el => el.id), "Starting");
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  private stopInstances(studentInstances: IStudentInstance[]){
    stopStudentInstances({ studentInstances: studentInstances }).then(
      (response: any) => {
        this.updateStudentInstanceStatusIds(studentInstances.map(el => el.id), "Stopping");
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  private resetInstances(studentInstances: IStudentInstance[]){
    resetStudentInstances({ studentInstances: studentInstances }).then(
      (response: any) => {
        this.updateStudentInstanceStatusIds(studentInstances.map(el => el.id), "Resetting");
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  private async launchLabInstance(row: any, connectionType: string) {
    let href: string = "";
    switch(row.box.machineTypeCode) {
      case MachineType.Linux:
        if (connectionType === "terminal") {
          href = `${guacClientUrl}${row.guacTerminalId}`;
        } else {
          href = `${guacClientUrl}${row.guacDesktopId}`;
        }
        break;
      case MachineType.Window:
        href = `${guacClientUrl}${row.guacDesktopId}`;
        break;
      case MachineType.Ubuntu:
        href = `${guacClientUrl}${row.guacTerminalId}`;
        break;
    }

    window.open(href, '_blank');
  }

  private handleUpdate(row: any) {}

  private addTime(row: IStudentInstance) {
    if (this.needAddTime(row)) {
      addTimeForStudentInstances({ studentInstances: [row] }).then(
        (response: any) => {
          row.timeToShutDown = moment.utc(new Date(row.timeToShutDown)).add(1, 'hours').utc().format();
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  private needAddTime(row: IStudentInstance) {
    let remainingTime: number = this.getTimeRemainingInSeconds(row.timeToShutDown);
    return row.instanceStatus === "Active" && (remainingTime < (4*3600));
  }
}
